import React, {Component} from 'react';
import {Grid, Button, FormGroup, FormControl} from 'react-bootstrap';
import './About.css';


export default class About extends Component {

    render() {
        return (
            <Grid>

                <p>
                Anadolu Üniversitesi, Dijital Yayın Merkezi Öğrenme Teknolojileri Araştırma
                Geliştirme (ÖTAG) Birimi bünyesinde faaliyet göstermektedir. Bu projenin ana amacı Açık ve
                Uzaktan Öğrenme (AUÖ) hareketinin özünde yatan açıklık felsefesi doğrultusunda “bilgi
                insanlığın ortak malıdır” düşüncesi doğrultusunda alana katkı sağlayan kitap, makale, rapor
                gibi farklı yayın türlerini erişime açmak ve bu şekilde Açık Ders Kaynakları (ADK) hareketine
                ayrıca katkı sağlamaktır.
                </p>
            </Grid>

        )
    }

}




// WEBPACK FOOTER //
// ./src/components/About.js